import { Cursor, Eye, Star } from '@phosphor-icons/react';
import { useScreenView } from '../../../../../../utils/ScreenViewContext';

function MetricsWidget() {
  const { screenView } = useScreenView();

  const renderScreenView = (screenView: string) => {
    switch (screenView) {
      case 'desktop':
      case 'tablet':
      case 'mobile':
        return (
          <div className="flex w-[100%] items-center justify-center gap-4 align-middle sm:flex-col lg:flex-row">
            <div className="relative flex max-h-[136px] w-full flex-row items-center gap-x-[16px] border-[1px] border-bordergray bg-white p-4 align-middle lg:max-w-[372px]">
              <div className="absolute right-2 top-2 rounded-[8px] border-[1px] border-accent px-[6px] py-[1px]">
                <p className="text-accent opacity-[100%]">Coming Soon!</p>
              </div>
              <div className="max-w-[20%] rounded-[4px] border-[1px] border-[#EAECF0] bg-[#F5F6F7] p-[12px] opacity-[60%]">
                <Star size={30} />
              </div>
              <div className="flex w-[80%] flex-col items-start align-middle opacity-[60%]">
                <h2 className="text-[14px] text-[#0A112F]">AVG Rating</h2>
                <h1 className="text-[30px] font-[700] leading-[40px] text-primary">
                  4.9
                </h1>
                <h2 className="text-[14px] text-[#0A112F] opacity-50">
                  Last 24 Hours: 12 Reviews
                </h2>
              </div>
            </div>

            <div className="relative flex max-h-[136px] w-full flex-row items-center gap-x-[16px] border-[1px] border-bordergray bg-white p-4 align-middle lg:max-w-[372px]">
              <div className="absolute right-2 top-2 rounded-[8px] border-[1px] border-accent px-[6px] py-[1px]">
                <p className="text-accent opacity-[100%]">Coming Soon!</p>
              </div>
              <div className="max-w-[20%] rounded-[4px] border-[1px] border-[#EAECF0] bg-[#F5F6F7] p-[12px] opacity-[60%]">
                <Eye size={30} />
              </div>
              <div className="flex w-[80%] flex-col items-start align-middle opacity-[60%]">
                <h2 className="text-[14px] text-[#0A112F]">Total Views</h2>
                <h1 className="text-[30px] font-[700] leading-[40px] text-primary">
                  2367
                </h1>
                <h2 className="text-[14px] text-[#0A112F] opacity-50">
                  Last 24 Hours: 236 views
                </h2>
              </div>
            </div>

            <div className="relative flex max-h-[136px] w-full flex-row items-center gap-x-[16px] border-[1px] border-bordergray bg-white p-4 align-middle lg:max-w-[372px]">
              <div className="absolute right-2 top-2 rounded-[8px] border-[1px] border-accent px-[6px] py-[1px]">
                <p className="text-accent opacity-[100%]">Coming Soon!</p>
              </div>
              <div className="max-w-[20%] rounded-[4px] border-[1px] border-[#EAECF0] bg-[#F5F6F7] p-[12px] opacity-[60%]">
                <Cursor size={30} />
              </div>
              <div className="flex w-[80%] flex-col items-start align-middle opacity-[60%]">
                <h2 className="text-[14px] text-[#0A112F]">Total Clicks</h2>
                <h1 className="text-[30px] font-[700] leading-[40px] text-[#1D213B]">
                  435
                </h1>
                <h2 className="text-[14px] text-[#0A112F] opacity-50">
                  Last 24 Hours: 48 clicks
                </h2>
              </div>
            </div>
          </div>
        );
    }
  };
  return <>{renderScreenView(screenView)}</>;
}

export default MetricsWidget;
